import { type Event } from '@src/pages/journey-map/types';

interface SankeyNode {
  id: string;
  name: string;
  layer: number;
  value: number;
  flow: number;
  pathId: string;
  nwrs: string[];
  duration: number;
  prob: number;
  isHighlighted: boolean;
}

interface SankeyLink {
  source: string;
  target: string;
  value: number;
  flow: number;
  pathId: string;
}

interface SankeyData {
  nodes: SankeyNode[];
  links: SankeyLink[];
}

export function generateSankeyData(
  data: Event[][],
  isEndWith?: boolean,
  isStartWith?: boolean,
): SankeyData {
  const paths = data.filter((item) => item.length > 1);

  if (!paths.length) {
    return { nodes: [], links: [] };
  }

  const nodes: SankeyNode[] = [];
  const links: SankeyLink[] = [];
  const nodeMap = new Map<string, SankeyNode>();
  // Process each path
  const maxLayer = Math.max(...paths.map((path) => path.length));
  paths.forEach((path) => {
    const pathData = [...path];

    const pathNodes: any[] = [];

    // fill placeholder to max layer
    // if (isEndWith && isStartWith) {
    //   if (pathData.length !== maxLayer) {
    //     const startEvent = pathData[0];
    //     const postArr = pathData.slice(1);
    //     const fill = [];
    //     for (let i = 0; i < maxLayer - pathData.length; i++) {
    //       fill.push({ ...startEvent, mapped_event_name: startEvent.pathId, prob: 1 });
    //     }
    //     pathData = [startEvent, ...fill, ...postArr];
    //   }
    // }

    pathData.forEach((event, index) => {
      const { flow, pathId, mapped_event_name } = event;
      let layer = index;
      if (isEndWith) {
        layer = maxLayer - pathData.length + index;
        // move start event to first one
        if (isStartWith) {
          layer = index === 0 ? 0 : layer;
        }
      }
      const nodeId = `${mapped_event_name}_${layer}`;
      const value = flow;
      const node: SankeyNode = {
        id: nodeId,
        name: event.mapped_event_name,
        layer,
        value: 100,
        pathId,
        flow,
        nwrs: event.nwrs || [],
        duration: event.duration || 0,
        prob: event.prob,
        isHighlighted: event.isMatched || false,
      };

      // for generate link
      pathNodes.push(node);

      // Create node if it doesn't exist
      if (!nodeMap.has(nodeId)) {
        nodes.push(node);
        nodeMap.set(nodeId, node);
      }
    });

    pathNodes.forEach((node, index) => {
      if (index < pathNodes.length - 1) {
        const sourceEvent = node;
        const nextEvent = pathNodes[index + 1];

        links.push({
          source: sourceEvent.id,
          target: nextEvent.id,
          value: nextEvent.value,
          flow: nextEvent.flow,
          pathId: sourceEvent.pathId,
          nwrs: sourceEvent.nwrs || [],
          duration: sourceEvent.duration || 0,
          flow_conversion: nextEvent.flow / sourceEvent.flow,
          prob: nextEvent.prob || 0,
        });
      }
    });
  });

  return {
    nodes,
    links,
  };
}
